import { subscribe } from 'communicator/store';
import { getIsCheckoutDataReady } from 'communicator/store/selectors';

export default async function appLoaded(): Promise<void> {
  // For Visa SRCi, DCF is launched after data is already ready
  if (getIsCheckoutDataReady()) {
    return;
  }

  // For external SRCi/PSP, app is launched early to get around Safari popup blocker.
  // In this case we need to wait for the checkout data to become available.
  await new Promise<void>(resolve => {
    const unsubscribe = subscribe(getIsCheckoutDataReady, isCheckoutDataReady => {
      if (isCheckoutDataReady) {
        unsubscribe();
        resolve();
      }
    });
  });
}
